var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJavascript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 100,
    viewBox: "0 0 150 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3785_11306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93 32H57V68H93V32Z",
    fill: "#F7DF1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.183 60.125C81.9081 61.309 82.8516 62.1793 84.5201 62.1793C85.9219 62.1793 86.8173 61.4787 86.8173 60.5107C86.8173 59.3507 85.8973 58.9399 84.3544 58.265L83.5087 57.9021C81.0676 56.8621 79.4459 55.5593 79.4459 52.805C79.4459 50.2679 81.379 48.3364 84.4001 48.3364C86.551 48.3364 88.0973 49.085 89.2116 51.045L86.5773 52.7364C85.9973 51.6964 85.3716 51.2867 84.4001 51.2867C83.4093 51.2867 82.7813 51.9153 82.7813 52.7364C82.7813 53.7513 83.4099 54.1621 84.8613 54.7907L85.707 55.153C88.5813 56.3856 90.2041 57.6421 90.2041 60.4673C90.2041 63.513 87.8116 65.1816 84.5984 65.1816C81.4567 65.1816 79.427 63.6844 78.4339 61.7221L81.183 60.125ZM69.2327 60.4181C69.7641 61.361 70.2476 62.1581 71.4099 62.1581C72.5213 62.1581 73.2224 61.7233 73.2224 60.0324V48.5296H76.6053V60.0781C76.6053 63.581 74.5516 65.1753 71.5539 65.1753C68.8453 65.1753 67.2767 63.7736 66.479 62.0853L69.2327 60.4181Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3785_11306"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 32,
    width: 36,
    height: 36,
    rx: 3,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.9cdc29c50c4e375d42585cc4b481ad24.svg";
export { ForwardRef as ReactComponent };